import styled from 'styled-components'

export const IndicatorWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 110px;
  width: 8px;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
`
export const Indicator = styled.div`
  position: relative;
  width: 8px;
  display: flex;
  flex-direction: column;
`
export const Item = styled('div')`
  height: 8px;
  width: 8px;
  margin-bottom: 8px;
  background: ${(props) => props.theme.colors.dotIndicator.background};
  border-radius: 4px;
  &:last-child {
    margin-bottom: 0;
  }
`
export const CurrentItem = styled.div<{
  $position: number
}>`
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props) =>
    props.theme.colors.dotIndicator.activeElem.background};
  height: 56px;
  width: 8px;
  border-radius: 4px;
  z-index: 1;
  transition: all 0.3s ease;
  transform: ${({ $position }) =>
    $position ? `translateY(${16 * $position}px)` : ''};
`
